import { useCallback, useMemo, useState } from 'react';
import useCookie, { Cookie } from '../useCookie';

const STUDY_LIST_COOKIE_NAME = 'study_list';

export function useUserPreferences() {
  // TODO: later add all other user preference related cookies here
  // each can have its own update function to be returned by this hook
  const [studyListCookie, saveStudyListCookie] = useCookie(
    STUDY_LIST_COOKIE_NAME
  );
  const [studyListPreferences, setStudyListPreferences] = useState<Cookie>(
    studyListCookie
  );

  const updateStudyListPreferences = useCallback(
    (newPrefs: Partial<Cookie>) => {
      const updated = { ...studyListPreferences, ...newPrefs };

      setStudyListPreferences(updated);
      saveStudyListCookie(updated, { expiresInDays: 365 });
    },
    [setStudyListPreferences, saveStudyListCookie, studyListPreferences]
  );

  return useMemo(
    () => ({
      studyListPreferences,
      updateStudyListPreferences,
    }),
    [studyListPreferences, updateStudyListPreferences]
  );
}
